import type { EdgeTypes } from "@xyflow/react";
import { RuleGraphFlowEdgeLine } from "./RuleGraphFlowEdgeLine";
import { RuleGraphRoutedEdge } from "./RuleGraphRoutedEdge";

export const RULE_GRAPH_EDGE_TYPES: EdgeTypes = {
  ruleGraphFlow: RuleGraphFlowEdgeLine,
  ruleGraphRouted: RuleGraphRoutedEdge,
};
